module.exports = __webpack_public_path__ + "img/bag-x.f923930d.svg";